import { Building2, Users2, Award } from "lucide-react";
import { COMPANY, INTEGRATED_ADVANTAGE } from "@/lib/content";

/**
 * Who We Are — sits between Hero and GroupCompanies grid.
 * Two-column narrative + right-side "Integrated Advantage" 3-card band inline.
 */
export default function WhoWeAre() {
  return (
    <section
      id="who-we-are"
      data-testid="who-we-are-section"
      className="relative bg-white py-24 md:py-32"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-20">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 mb-24">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-3 mb-6">
              <span className="gold-hairline" />
              <span className="text-gold text-[11px] uppercase tracking-[0.28em] font-medium">Who We Are</span>
            </div>
            <h2 className="font-serif text-navy text-3xl md:text-4xl lg:text-5xl font-light leading-[1.1] tracking-[-0.01em]">
              One professional platform.
              <br />
              <em className="text-gold not-italic">Seven disciplines.</em>
              <br />
              Under one Group.
            </h2>
          </div>
          <div className="lg:col-span-7 space-y-6 text-navy text-[17px] leading-[1.75] font-light">
            <p>
              Salihi Group is a diversified professional services group established in
              <strong className="font-normal"> {COMPANY.established}</strong>, headquartered in Mogadishu, Somalia.
              The Group brings seven specialised companies together under a single corporate platform — providing legal,
              consulting, engineering, investment, mining, Oil & Gas, and workforce services to organisations operating in Somalia
              and the wider region.
            </p>
            <p>
              Our purpose is to give clients access to the professional support they need through one coordinated
              relationship. Whether a matter requires the depth of a single specialist or the coordination of several,
              Salihi Group operates as one team — with shared standards for quality, confidentiality, and delivery
              discipline across every subsidiary.
            </p>
          </div>
        </div>

        {/* Integrated Advantage 3-column band */}
        <div className="grid md:grid-cols-3 gap-0 border border-softgray divide-y md:divide-y-0 md:divide-x divide-softgray">
          {INTEGRATED_ADVANTAGE.map((c, i) => {
            const Icon = [Building2, Award, Users2][i] || Building2;
            return (
              <div
                key={c.title}
                data-testid={`integrated-advantage-${i}`}
                className="p-8 md:p-10 flex flex-col group hover:bg-offwhite transition-colors"
              >
                <div className="flex items-center gap-3 mb-5">
                  <Icon size={22} strokeWidth={1.5} className="text-gold" />
                  <span className="text-gold text-[10px] uppercase tracking-[0.28em] font-mono">0{i + 1}</span>
                </div>
                <h3 className="font-serif text-navy text-xl leading-tight mb-3">{c.title}</h3>
                <p className="text-mutedink text-[15px] leading-relaxed font-light">{c.body}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
